<template>
  <div v-if="isUndefinedOrder" class="box">
    <img src="../../../assets/img-v2/ic_unfinished_order.png" class="icon" />
    <!-- 一条未完成订单，跳转订单详情页/待支付页 -->
    <template v-if="orderNum === 1">
      <div class="row" v-if="isPenddingOrder" @click="onRunningOrder">
        <div class="text">您有{{ orderNum }}个进行中的订单，点击查看</div>
        <img
          src="../../../assets/img-v2/ic_unfinished_order_arrow.png"
          class="arrow"
        />
      </div>
      <div class="row nopay" v-else-if="isNotPayOrder" @click="onNoPayOrder">
        <div class="text">您有{{ orderNum }}个未支付订单，点击查看</div>
        <img
          src="../../../assets/img-v2/ic_unfinished_order_arrow.png"
          class="arrow"
        />
      </div>
    </template>

    <!-- 多条未完成订单，跳转订单列表页 -->
    <template v-else>
      <div class="row" @click="onOrderList">
        <div class="text">您有{{ orderNum }}个进行中的订单，点击查看</div>
        <img
          src="../../../assets/img-v2/ic_unfinished_order_arrow.png"
          class="arrow"
        />
      </div>
    </template>
  </div>
</template>

<script>
import {
  ORDER_STATUS_CODES_NOT_PAY,
  ORDER_STATUS_CODES_DISPATCHING,
  ORDER_STATUS_CODES_NOT_GET_ON,
  ORDER_STATUS_CODES_RUNNING,
} from "@/views/order/service";

export default {
  props: {
    orderInfo: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {};
  },
  computed: {
    isServiceManager() {
      return this.$UserService.isServiceManager();
    },
    orderNum() {
      return this.orderInfo ? this.orderInfo.undefinedNum : 0;
    },
    isUndefinedOrder() {
      return this.orderNum > 0;
    },
    firstOrder() {
      if (this.isUndefinedOrder && this.orderNum === 1) {
        const { undefinedOrders } = this.orderInfo || {};
        const [order] = undefinedOrders || [];
        return order;
      }
      return null;
    },
    isPenddingOrder() {
      return (
        this.firstOrder &&
        [
          ...ORDER_STATUS_CODES_DISPATCHING,
          ...ORDER_STATUS_CODES_NOT_GET_ON,
          ...ORDER_STATUS_CODES_RUNNING,
        ].includes(this.firstOrder.status) &&
        !this.isServiceManager
      );
    },
    isNotPayOrder() {
      return (
        this.firstOrder &&
        [...ORDER_STATUS_CODES_NOT_PAY].includes(this.firstOrder.status)
      );
    },
  },
  methods: {
    onRunningOrder() {
      if (this.firstOrder) {
        this.$OrderService.turnToOrderRunning(
          {},
          {
            ticketInfoId: this.firstOrder.id,
          }
        );
      }
    },
    // 未支付订单
    onNoPayOrder() {
      if (this.firstOrder) {
        this.$OrderService.turnToOrderPay(
          {
            from: "Home",
          },
          {
            ticketInfoId: this.firstOrder.id,
          }
        );
      }
    },
    onOrderList() {
      this.$OrderService.turnToOrdersView();
    },
  },
};
</script>

<style scoped lang="scss">
.box {
  width: max-content;
  position: relative;
  display: flex;
  align-items: center;
}
.icon {
  width: 44px;
  height: 44px;
  position: absolute;
}

.row {
  display: flex;
  align-items: center;
  padding: 11px 8px 9px 50px;
  background: linear-gradient(90deg, #c0dfff 0%, #dcf0ff 100%);
  box-shadow: 0px 4px 10px 0px rgba(172, 186, 225, 0.5);
  border-radius: 12px;
  border: 1px solid #ffffff;
  overflow: hidden;
}

// .nopay {
//   background: linear-gradient(90deg, #ff3b30 0%, rgba(255, 59, 48, 0.2) 100%);
//   .text {
//     color: #ff3b30;
//   }
// }

.text {
  max-width: 220px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #006efa;
  line-height: 20px;
  text-align: left;
  font-style: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.arrow {
  width: 16px;
  height: 16px;
  margin-left: 4px;
}
</style>
